// extracted by mini-css-extract-plugin
var _1 = "CategoryHeadingButton-module__icon--vYQBB";
export { _1 as "icon" }
